<style scoped>
    .title{
        font-size: 20px;
        font-weight: bold;
        padding: 10px;
        border-bottom: 1px solid #dddee1;
        margin-bottom: 10px;
    }
    .card{
        display: inline-block;
        width: 250px;
        padding: 10px;
        margin-right: 10px;
        margin-bottom: 10px;
        border: 1px solid #dddee1;
        text-align: left;
    }
    .card-title{
        font-weight: bold;
    }
    .card-btn{
        float: right;
        cursor: pointer;
    }
    .card-btn:hover{
        color: #2b62e4;
    }
    .card-name{
        margin-top: 10px;
        border-top: 1px solid #dddee1;
        padding-top: 10px;
    }
</style>
<template>
  <div class="text-center">
    <div class="title">
      群组列表
    </div>
    <div
      v-for="group in groups"
      :key="group.id"
      class="card"
    >
      <span class="card-title">
        <Icon type="ios-people-outline" />
        {{ group.title }}
      </span>
      <span
        class="card-btn color-info"
        @click.prevent="showGroupDetail(group)"
      >
        <Icon type="ios-eye-outline" />
        查看
      </span>
      <div class="card-name">
        {{ group.name }}
      </div>
    </div>
  </div>
</template>
<script route="/auth/group">
  import Util from '../../libs/util';
  export default {
    /* router_info_start */
    router_info: '/auth/group',
    /* router_info_end */
    data() {
      return {
        groups: []
      }
    },
    computed: {

    },
    created() {
      this.getGroups();
    },
    mounted() {
      //
    },
    methods: {
      getGroups() {
        console.log('Util.api.get_groups', Util.api.get_groups)
        Util.ajax.get(Util.api.get_groups, {
          //
        }).then((response) => {
          return response.data;
        }).then((data) => {
          this.groups = [];
          data.forEach((group) => {
            this.groups.push(group);
          })
        }).catch((e) => {
          console.log(e);
        });
      },
      showGroupDetail(group) {
        this.$router.push('/auth/group_detail/' + group.id);
      }
    }
  }
</script>
